// src/admin/auth/ProtectedRoute.tsx
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export function ProtectedRoute() {
  const { status, aal, admin } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <div style={{ padding: 32 }}>Loading…</div>;
  }

  if (status !== 'signed_in') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Signed in but not yet AAL2 — route to TOTP challenge or enrolment
  if (aal !== 'aal2') {
    return <Navigate to="/login/totp" replace />;
  }

  // Signed in + AAL2 but not in admin_users (rare: account exists but row missing)
  if (!admin || !admin.is_active) {
    return <Navigate to="/login?error=not_authorized" replace />;
  }

  return <Outlet />;
}
